import { getNextPageParam, useInfiniteQuery } from '@fv/client-core'

import { defaultPageSize } from '@/constants'
import { opportunityQueryKeys } from '@/queryKeys'
import type { PagedOpportunities } from '@/types/Opportunity'
import { carrierFetch } from '@/utils/carrierFetch'

async function searchOpportunities({
  searchText,
  skip,
}: {
  searchText: string
  skip: number
}): Promise<PagedOpportunities> {
  return carrierFetch<PagedOpportunities>(`/opportunities/search`, {
    query: {
      limit: defaultPageSize,
      skip,
      searchText,
    },
  })
}

export function useOpportunitySearch(searchText: string) {
  return useInfiniteQuery({
    queryKey: opportunityQueryKeys.bySearchText(searchText),
    queryFn: ({ pageParam }) =>
      searchOpportunities({ searchText, skip: pageParam }),
    initialPageParam: 0,
    enabled: Boolean(searchText),
    getNextPageParam,
  })
}
